<script lang="ts" setup>
import type { EditorHeaderProps } from "./editor.types";
import { useEditorHeader } from "./useEditorHeader";
import { editorHeaderClasses, editorHeaderLabelClasses, editorHeaderTrailingClasses } from "./Editor.styles";

const props = defineProps<EditorHeaderProps>();

const { languageIconName, languageLabel, handleCopy } = useEditorHeader({ props });
</script>

<template>
  <figcaption part="base" :class="editorHeaderClasses">
    <span part="label" :class="editorHeaderLabelClasses">
      <e-icon exportparts="base:label-icon" :name="languageIconName" size="xs" />
      {{ languageLabel }}
    </span>
    <span part="trailing" :class="editorHeaderTrailingClasses">
      <slot name="trailing">
        <e-button
          exportparts="base:copy-button"
          class="dark"
          square
          icon="copy"
          size="xs"
          variant="ghost"
          @click="handleCopy"
        />
      </slot>
    </span>
  </figcaption>
</template>

<style>
:host {
  display: contents;
}
</style>
